<template>
<div class="chapter">
<div class="inner_page">
<p class="crt" id="d7e554">First Edition<br/>10 09 08       5 4 </p>
<p class="crt" id="d7e634">Text © 2006 by Michelle Gringeri-Brown<br/>Photographs © 2006 by Jim Brown </p>
<p class="crt" id="d7e844">All rights reserved. No part of this book may be reproduced by any means whatsoever without written permission from the publisher, except brief portions quoted for purpose of review.</p>
<p class="crt" id="d7e974">Published by<br/>Gibbs Smith, Publisher<br/>P.O. Box 667<br/>Layton, Utah 84041 </p>
<p class="crt" id="d7e1144">Orders: 1.800.748.5439<br/><a href="http://www.gibbs-smith.com" id="d14e76" target="_blank">www.gibbs-smith.com</a></p>
<p class="crt" id="d7e1274">Designed by Deibra McQuiston<br/>Printed and bound in China </p>
<p class="crt" id="d7e1384">Library of Congress Cataloging-in-Publication Data<br/>Gringeri-Brown, Michelle.<br/>Atomic ranch : design ideas for stylish ranch homes /Michelle Gringeri-Brown;<br/>photographs by Jim Brown.-—1st ed.<br/>     p. cm.<br/>   ISBN 10: 1-4236-0002-9 : ISBN 13: 978-1-4236-0002-2<br/>   1. Ranch houses—United States. 2. Architecture—United States—20th century.<br/>I. Title.</p>
<p class="crt" id="d7e1894">NA7208.G75 2006<br/>728'.3730973--dc22 </p>
<p class="crt" id="d7e2044">2006004614 </p>
<p class="ser"><img alt="AtomicRanchBook_0004_002" id="d14e105" src="images/AtomicRanchBook_0004_002.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Grin_ISBN9781423600022_epub_c5_r1.vue?d26a7240